import { extrairETruncarNumeros, converterDataParaISO } from './util';
import {
    serviceSalvarLog
} from './Service/service';

export const mapeamentoEtapaUmPF = (obj, tipoFiliacao) => {

    try {
        const retorno = {
            InTitClasseCa: obj?.compositorAutorAutorais ? 'S' : 'N',
            InTerrAdmAutoral: obj?.territorioAdmAutorais == 'Outros' ? 0 : obj?.territorioAdmAutorais || 0,
            InOutrosTerrAdmAutoral: obj?.territorioAdmAutoraisOutro,
            InTitClasseE: obj?.editor ? 'S' : 'N',
            InTitClasseI: obj?.interpreteConexao ? 'S' : 'N',
            InTitClasseMu: obj?.musicoConexao ? 'S' : 'N',
            InTitClassePf: obj?.produtorFonograficoConexao ? 'S' : 'N',
            InTerrAdmConexo: obj?.territorioAdmConexao == 'Outros' ? 0 : obj?.territorioAdmConexao || 0,
            InOutrosTerrAdmConexo: obj?.territorioAdmConexaoOutro,

            InClasseDecNaofiliacaoCa: obj?.compositorAutorNaoFiliacao ? 'S' : 'N',
            InClasseDecNaofiliacaoI: obj?.interpreteNaoFiliacao ? 'S' : 'N',
            InClasseDecNaofiliacaoMu: obj?.musicoNaoFiliacao ? 'S' : 'N',
            InClasseDecNaofiliacaoPf: obj?.produtorFonograficoNaoFiliacao ? 'S' : 'N',
            InClasseDecNaofiliacaoE: obj?.editorNaoFiliacao ? 'S' : 'N',
            // NuSeqPfiliacao: obj,

            InClasseDecfiliacaoCa: obj?.compositorAutorFiliado ? 'S' : 'N',
            InClasseDecfiliacaoI: obj?.InterpreteFiliado ? 'S' : 'N',
            InClasseDecfiliacaoMu: obj?.musicoFiliado ? 'S' : 'N',
            InClasseDecfiliacaoPf: obj?.produtorFonograficoFiliado ? 'S' : 'N',
            InClasseDecfiliacaoE: obj?.editorFiliado ? 'S' : 'N',

            NmSociedadeFiliadoCa: obj?.sociedadeCompositorAutor || null,
            NmSociedadeFiliadoI: obj?.sociedadeInterprete || null,
            NmSociedadeFiliadoMu: obj?.sociedadeMusico,
            NmSociedadeFiliadoPf: obj?.sociedadeProdutor,
            NmSociedadeFiliadoE: obj?.sociedadeEditor,

            FlNacional: obj?.tipoFiliacao?.toLowerCase() == 'estrangeiro' ? 'N' : 'S',
            InTipoFiliacao: tipoFiliacao,

            // - unidade atend
            NmContatoInterno: obj?.contatoAtendimento,
            DsComoConheceuUbc: `${obj?.comoConheceuUBC || ''}`,
            DsQuemIndicouUbc: `${obj?.quemIndicouUBC || ''}`,

            NmUsuInc: 'WEB',
            FlTipoPgto: 'D',
            NuSeqPfilStatus: 8,
            CdCentroCusto: `${obj?.unidadeAtendimento?.cCusto}` || '1',
            CdFilial: `${obj?.unidadeAtendimento?.id}` || '1',
            DtInc: new Date().toISOString(),

        };
        return retorno;
    } catch (error) {
        console.error(error, 'DTO Etapa 1')
        throw error;
    }
}

export const mapeamentoEtapaDoisPF = (obj) => {
    try {
        const retorno = {
            NmNomeRazaosocial: obj?.nomeCompleto || obj?.razaoSocial,
            NmSocial: obj?.nomeSocial || ' ',
            NmNomeArtisticoFantasia: obj?.nomeArtistico || obj?.nomeFantasia || ' ',
            NmPseudo: obj?.pseudonimoColetivo,

            NuCpfCnpj: obj?.cpf?.replace(/\D/g, '') || obj?.cnpj?.replace(/\D/g, ''),
            DtNascimento: obj?.dataNascimento,
            NuIdentidade: obj?.identidade,
            NmOrgaoExped: obj?.orgaoExpedidor,

            NmNacionalidade: `${obj?.nacionalidade?.nome || ''}`,
            CdNacionalidade: obj?.nacionalidade?.id,
            NmNaturalidade: obj?.naturalidade,
            InSexo: obj?.genero?.charAt(0).toUpperCase(),

            InEstadoCivil: obj?.estadoCivil?.charAt(0)?.toUpperCase(),
            InMenorRep: obj?.menorDe15 == 'true' ? true : false,
            IsTitSucessor: obj?.falecido == 'true' ? true : false,

            oPFiliacaoDTO: obj?.falecido === 'true' ? mapeamentoEtapaDoisPFFalecido(obj) : {},

            DsObs: obj?.sobreCarreira,
            DsExecucaoPublica: `${obj?.musicasPublicas || ''}`,
            DsParticipacoes: `${obj?.links || ''}`,

            NmTitSucessor: obj?.nomeOutorganteFalecido,
            NmNatJurFalecido: obj?.naturezaJuridicaDocOutorganteFalecido,
            DtObito: converterDataParaISO(obj?.dtFalecimentoOutorganteFalecido),
            NmVaraFalecido: obj?.varaOutorganteFalecido,
            NmComarcaFalecido: obj?.comarcaOutorganteFalecido,
            DtDocsFalecido: obj?.dataOutorganteFalecido,
        };
        return {
            ...retorno,
            ...(obj?.menorDe15 === 'true' && mapeamentoEtapaDoisPFMenorQuinze(obj)),
        };

    } catch (error) {
        console.error(error, 'DTO Etapa 2')
        throw error;
    }
}

const mapeamentoEtapaDoisPFMenorQuinze = (obj) => {
    try {

        return {
            NmNomeRazaosocialMR: obj?.nomeRepresentanteQuinze,
            NuCpfCnpjMR: obj?.cpfRepresentanteQuinze?.replace(/\D/g, ''),
            NuIdentidadeMR: obj?.rgRepresentanteQuinze?.replace(/\D/g, ''),
            NmOrgaoExpedMR: obj?.rgOERepresentanteQuinze,
            NuCelMR: obj?.celularRepresentanteQuinze?.replace(/\D/g, ''),
            NmEmailMR: obj?.emailRepresentanteQuinze
        };
    } catch (error) {
        console.error(error, 'DTO Etapa 2 - Quinze')
        throw error;
    }
}

const mapeamentoEtapaDoisPFFalecido = (obj) => {
    try {
        return {
            DtObito: converterDataParaISO(obj?.dtFalecimentoOutorganteFalecido),
            NmSucessor: obj?.nomeOutorganteFalecido,
            NmNacionalidade: `${obj?.nacionalidadeOutorganteFalecido?.nome || ''}`,
            NuIdentidade: obj?.rgOutorganteFalecido,
            NmOrgaoExped: obj?.rgOEOutorganteFalecido,
            NmNatJur: obj?.naturezaJuridicaDocOutorganteFalecido,
            NuCpfCnpj: obj?.cpfOutorganteFalecido,
            NmVara: obj?.varaOutorganteFalecido,
            NmComarca: obj?.comarcaOutorganteFalecido,
            DtDoc: obj?.dataOutorganteFalecido,
            NmLograd: obj?.endecoOutorganteFalecido,
            NuLograd: obj?.numeroOutorganteFalecido,
            DsComplLograd: obj?.complementoOutorganteFalecido,
            CdCep: extrairETruncarNumeros(obj?.cepOutorganteFalecido, 8),
            CdUf: obj?.estadoOutorganteFalecido,
            NmCidade: obj?.cidadeJuridicaDocOutorganteFalecido,
            NmBairro: obj?.bairroJuridicaDocOutorganteFalecido,
            NmEstadoCivil: obj?.estadoCivilOutorganteFalecido?.charAt(0)?.toUpperCase(),
            IsTitSucessor: true,
        };
    } catch (error) {
        console.error(error, 'DTO Etapa 2 sucessos')
        throw error;
    }
}

export const mapeamentoEtapaTres = (obj) => {
    try {
        return {
            CdCep: extrairETruncarNumeros(obj?.cep, 8),
            NmLograd: obj?.endereco,
            NuLograd: obj?.numero ?? 'S/N',
            DsComplLograd: obj?.complemento,
            NmBairro: obj?.bairro,
            NmCidade: obj?.cidade,
            CdUf: obj?.estado,
            NuTel: obj?.telefone?.replace(/\D/g, ''),
            NuCel: obj?.celular?.replace(/\D/g, ''),
            NmEmail: obj?.email,
        };
    } catch (error) {
        console.error(error, 'DTO Etapa 3')
        throw error;
    }
}

export const mapeamentoEtapaQuatro = (obj) => {
    try {
        const retorno = {
            NmUrlFacebook: obj?.facebook,
            NmUrlInstagram: obj?.instagram,
            NmUrlLinkedin: obj?.linkedin,
            NmUrlSite: obj?.site,
            NmUrlTiktok: obj?.tiktok,
            NmUrlTwitter: obj?.xantigoTwitter,
            NmUrlYoutube: obj?.youtube,
            NmUrlThreads: obj?.threads,
            NmUrlSpotify: obj?.spotify,
            NmUrlDeezer: obj?.deezer,
        };
        return retorno;
    } catch (error) {
        console.error(error, 'DTO Etapa 4')
        throw error;
    }
}

export const mapeamentoEtapaCinco = (obj, nacional) => {
    try {
        const refNacional = 'nacional';

        const retorno = {
            CdBanco: obj?.bancoCodigoNacional,
            NmBanco: obj?.bancoNacional || (nacional == refNacional ? "NÃO ENCONTRADO" : null),
            NuAgencia: obj?.bancoAgenciaNacional,
            NuAgenciaDv: obj?.bancoAgenciaDvNacional?.charAt(0),
            NuConta: obj?.bancoContaNacional,
            NuContaDv: obj?.bancoContaDvNacional?.charAt(0),
            NuContaOperacao: nacional == refNacional ? (`${obj?.numeroOperacaoNacional}` || '') : '',

            NmBancoRemessa: obj?.bancoInternacional,
            NuAgenciaRemessa: obj?.bancoAgenciaInternacional,
            CdIbanRemessa: obj?.bancoIbanInternacional,
            NuContaRemessa: obj?.bancoContaInternacional,
            CdSwiftRemessa: obj?.bancoSwiftInternacional,

            InTipoConta: nacional == refNacional ? obj?.bancoTipoContaNacional?.toUpperCase() : obj?.bancoTipoContaInternacional?.charAt(0)?.toUpperCase(),
            FlContaConjunta: nacional == refNacional ? obj?.bancoNaturezaContaNacional?.charAt(0)?.toUpperCase() : obj?.bancoNaturezaContaInternacional?.charAt(0)?.toUpperCase(),
            FlContaPrimCorrententista: nacional == refNacional ? obj?.bancoPosicaoContaNacional?.charAt(0)?.toUpperCase() : obj?.bancoPosicaoContaInternacional?.charAt(0)?.toUpperCase(),
        };
        return retorno;
    } catch (error) {
        console.error(error, 'DTO Etapa 5')
        throw error;
    }
}

// Configurações de validação de arquivos
const CONFIG_ARQUIVOS = {
    EXTENSOES_PERMITIDAS: ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx'],
    TAMANHO_MAX_MB: 10,
    TAMANHO_MAX_BYTES: 10 * 1024 * 1024 // 10MB
};

export const mapeamentoEtapaArquivos = (objs, _idFiliacao, pdfDocPrenchido, trackId = '') => {
    try {
        const formData = new FormData();
        const idFiliacao = _idFiliacao;
        const arquivos = [];
        const tipos = [];
        let arquivosInvalidos = 0;

        // PDF preenchido
        if (pdfDocPrenchido) {
            // Converter Blob para File object com nome e extensão
            const pdfFile = new File([pdfDocPrenchido], 'documento-assinatura.pdf', { 
                type: pdfDocPrenchido.type || 'application/pdf' 
            });
            
            if (validarArquivo(pdfFile)) {
                arquivos.push(pdfFile);
                tipos.push(12);
            } else {
                arquivosInvalidos++;
                serviceSalvarLog('mapeamentoEtapaArquivos', `Arquivo PDF inválido. filiação: ${_idFiliacao}`, '', 'WARNING', trackId);
            }
        }

        // Anexos do usuário
        if (objs && typeof objs === 'object') {
            Object.keys(objs).forEach((key) => {
                try {
                    const { id, obj } = objs[key];
                    if (obj && obj[0] && obj[0].size > 0) {
                        if (validarArquivo(obj[0])) {
                            arquivos.push(obj[0]);
                            tipos.push(id);
                        } else {
                            arquivosInvalidos++;
                            serviceSalvarLog('mapeamentoEtapaArquivos', `Arquivo inválido (key: ${key}). filiação: ${_idFiliacao}`, '', 'WARNING', trackId);
                        }
                    }
                } catch (error) {
                    serviceSalvarLog('mapeamentoEtapaArquivos', `Erro ao processar arquivo (key: ${key}). filiação: ${_idFiliacao}`, error.message, 'WARNING', trackId);
                }
            });
        }

        // Log apenas se houver arquivos inválidos
        if (arquivosInvalidos > 0) {
            serviceSalvarLog('mapeamentoEtapaArquivos', `${arquivosInvalidos} arquivo(s) inválido(s) ignorado(s). filiação: ${_idFiliacao}`, '', 'WARNING', trackId);
        }

        formData.append('IdFiliacao', idFiliacao);

        // Adicionar arquivos validados
        arquivos.forEach((arq) => {
            const extensaoArquivo = obterExtensaoArquivo(arq?.name || '');
            const nomeArquivo = extensaoArquivo ? `arquivo.${extensaoArquivo}` : arq.name;
            formData.append('Arquivos', arq, nomeArquivo);
        });

        // Adicionar tipos correspondentes
        tipos.forEach((tipo) => {
            formData.append('TipoArquivos', tipo);
        });

        return formData;

    } catch (error) {
        serviceSalvarLog('mapeamentoEtapaArquivos', `Erro na filiação: ${_idFiliacao} - ${error.message}`, JSON.stringify({ stack: error.stack }), 'ERROR', trackId);
        console.error(error, 'DTO Etapa 6 (arquivos)')
        throw error;
    }
}

const validarArquivo = (arquivo) => {
    if (!arquivo || !arquivo.name) {
        return false;
    }

    // Validar tamanho
    if (arquivo.size > CONFIG_ARQUIVOS.TAMANHO_MAX_BYTES) {
        console.warn(`Arquivo ${arquivo.name} excede tamanho máximo de ${CONFIG_ARQUIVOS.TAMANHO_MAX_MB}MB`);
        return false;
    }

    // Validar extensão
    const extensao = obterExtensaoArquivo(arquivo.name);
    if (!extensao) {
        console.warn(`Arquivo ${arquivo.name} não possui extensão válida`);
        return false;
    }
    
    if (!CONFIG_ARQUIVOS.EXTENSOES_PERMITIDAS.includes(extensao.toLowerCase())) {
        console.warn(`Extensão ${extensao} não permitida para arquivo ${arquivo.name}`);
        return false;
    }

    return true;
}

const obterExtensaoArquivo = (nomeArquivo) => {
    const ultimoPonto = nomeArquivo.lastIndexOf('.');
    if (ultimoPonto === -1 || ultimoPonto === 0) {
        return null;
    }
    return nomeArquivo.substring(ultimoPonto + 1);
}






